import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <img src="/ship-wheel.svg" alt="Loading..." className="spinning-wheel" />
    </div>
  );
};

export default Loader;
